import "./UserDetailsComponent.scss";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent from "../details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../services/common.service";
import {CommonService} from "../../services";
import React from "react";

interface UserDetailsComponentProps {
    user: any;
}

const UserDetailsComponent = (props: UserDetailsComponentProps) => {
    const {user} = props;
    return (
        <div className={'user-details-component'}>
            <div className="view-and-edit-title">
                Personal Details
            </div>
            <div className="details-tab-data-body">
                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"First Name"}> {commonService.capitalizeFirstLetterOfEachWord(user?.firstName) || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Last Name"}> {commonService.capitalizeFirstLetterOfEachWord(user?.lastName) || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Gender"}> {user?.gender || 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Middle Name"}> {commonService.capitalizeFirstLetterOfEachWord(user?.middleName) || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Date of Birth"}> {user?.dateOfBirth ? commonService.formatDate(user?.dateOfBirth) : 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                </Grid>
                <div className="horizontal-line"/>
                <div className="view-and-edit-title">Contact
                    Details
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {user?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(user?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Role"}> {user?.roleObj?.title || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
                {/*{*/}
                {/*    ["location", "facility", "lab"].map(key => (*/}
                {/*        labUser[key] && (*/}
                {/*            <>*/}
                {/*                <div className="horizontal-line"/>*/}
                {/*                <div*/}
                {/*                    className="view-and-edit-title">Linked*/}
                {/*                    Details*/}
                {/*                </div>*/}
                {/*                <div*/}
                {/*                    className="details-tab-data-body">*/}
                {/*                    <Grid container spacing={2}>*/}
                {/*                        <Grid item xs={12} sm={12}*/}
                {/*                              md={6} xl={6}>*/}
                {/*                            <DetailsDataKeyValueComponent*/}
                {/*                                title={key.charAt(0).toUpperCase() + key.slice(1)}> {labUser[key].name || 'N/A'} </DetailsDataKeyValueComponent>*/}
                {/*                        </Grid>*/}
                {/*                    </Grid>*/}
                {/*                </div>*/}
                {/*            </>*/}
                {/*        )*/}
                {/*    ))*/}
                {/*}*/}
            </div>
        </div>
    );

};

export default UserDetailsComponent;
